export default __webpack_public_path__ + "static/communications-c72db65995690ec7dd056835452e5cd4.png";